import React, { useRef, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useOutsideClick } from "../../hooks/useOutsideClick";
import { clearKeyTerm } from "../../store/actions";

const KeyTermModal = () => {
  const ref = useRef(null);
  const dispatch = useDispatch();
  const keyTerm = useSelector((state) =>
    state.ui.keyTerm ? state.keyTerms[state.ui.keyTerm] : false
  );

  useOutsideClick(ref, () => {
    dispatch(clearKeyTerm());
  });

  const title = useMemo(() => {
    if (!keyTerm) return "";

    return keyTerm.data.title || keyTerm.title;
  }, [keyTerm]);

  return (
    <div
      style={{
        position: "fixed",
        zIndex: 1000,
        opacity: 0.95,
        minHeight: "150px",
        bottom: 0,
        transform: keyTerm ? "translateY(0)" : "translateY(150px)",
        width: "100%",
        transition: "all ease 0.3s",
        boxShadow:
          "0 2px 6px 0 rgba(0, 0, 0, 0.2), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
      }}
      className="bg-gray-100"
      onClick={() => dispatch(clearKeyTerm())}
    >
      {keyTerm && (
        <div ref={ref}>
          <div
            className="container mx-auto text-center px-5 lg:px-0 py-8"
            style={{
              maxWidth: "600px",
            }}
          >
            <div className="font-bold text-lg">{title}</div>
            <div className="text-lg">{keyTerm.description}</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default KeyTermModal;
